// export const apiUrl = 'http://100.121.6.88:3001/graphql';
export const apiUrl = 'https://yk.madagx.com/graphql';



// WEBPACK FOOTER //
// ./src/graphql/url.js